<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-row>
      <v-col cols="12" md="12">
        <v-card
          class="border-radius box-shadow">
          <v-card-text class="py-0">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              :color="style.primary"
              slider-size="4">
              <v-tabs-slider :color="style.primary"></v-tabs-slider>
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                v-if="item.is_access == true || item.role == '*'"
                class="text-capitalize">
                <span class="body-2" :class="tab === index ? 'font-weight-bold color-default' : 'text-third'">
                  {{ item.label }}
                </span>
              </v-tab>
            </v-tabs>
            <v-divider/>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(item, index) in menu"
                v-if="item.is_access == true || item.role == '*'"
                :key="index">
                <router-view :model="tab"/>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tab: 0,
        menu: [
          {
            label: 'Booking Unit',
            value: '/approval/discount',
            role: ['superuser', 'supervisor']
          },
          {
            label: 'Biaya Lain-lain / Titipan',
            value: '/approval/other',
            role: ['superuser', 'finance']
          },
          {
            label: 'Down Payment',
            value: '/approval/dp',
            role: ['superuser', 'finance']
          },
          {
            label: 'Pembatalan Booking',
            value: '/approval/booking',
            role: ['superuser', 'supervisor']
          }
        ],
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
    },
    watch: {
      'tab': function(val) {
        this.$router.push({ path: `${this.menu[val].value}` })
      }
    },
    mounted () {
      var menu_temp = []

      this.menu.forEach(item => {
        item.is_access = false;

        this.user.user_company_roles_name.forEach(obj => {
          // console.log(obj)
          // console.log(item.role)
          // console.log(item.role.includes(obj))

          if (item.role.includes(obj)) {
            item.is_access = true;
            menu_temp.push(item)
          }          
        })
      })

      this.menu = menu_temp

      var can_use_first_tab = false;

      this.menu.forEach(item => {
        if (item.value == this.$route.path) {
          can_use_first_tab = true
        }
      })

      if (can_use_first_tab == true) {
        this.tab = this.$route.path === '/approval/discount' ? 0 : this.$route.path === '/approval/other' ? 1 : this.$route.path === '/approval/dp' ? 2 : 3
      } else {
        this.tab = this.$route.path === '/approval/discount' ? 1 : this.$route.path === '/approval/other' ? 1 : this.$route.path === '/approval/dp' ? 2 : 3
      }
      console.log(this.tab)
      console.log(this.$route.path)
    },
    methods: {
      
    }
  }
</script>